import _ from 'underscore';
module.exports = {
    parse: function (input) {
        let results = {};
        let components = input.gmaps.address_components;
        let street_number = _.find(components, function (c) {
            return _.indexOf(c.types, 'street_number') !== -1;
        });
        let street = _.find(components, function (c) {
            return _.indexOf(c.types, 'route') !== -1;
        });
        let city = _.find(components, function (c) {
            return _.indexOf(c.types, 'neighborhood') !== -1 || _.indexOf(c.types, 'locality') !== -1 || _.indexOf(c.types, 'sublocality') !== -1;
        });
        let zipcode = _.find(components, function (c) {
            return _.indexOf(c.types, 'postal_code') !== -1;
        });
        let state = _.find(components, function (c) {
            return _.indexOf(c.types, 'administrative_area_level_1') !== -1;
        });
        if (street && street_number)
            results.street = street_number.short_name + ' ' + street.short_name;
        if (city)
            results.city = city.short_name;
        if (zipcode)
            results.zipcode = zipcode.short_name;
        if (state)
            results.state = state.short_name;
        let lng = input.location.lng;
        let lat = input.location.lat;
        results.lng = lng;
        results.lat = lat;
        results.coords = [lng, lat];
        results.address = input.gmaps.formatted_address;
        return results;
    }
};
